export default "__VITE_ASSET__4ae99904__"